export const pl = {
  //Common
  clear: 'wyczyść',
  choose: 'Wybierz',
  show: 'Pokaż',
  delete: 'Usuń',
  no_options: 'Brak opcji',
  additional_operator_description:
    'Dodatkowy opis dostarczony przez operatora:',
  departure: 'wylot',
  arrival: 'przylot',
  departure_date: 'termin wylotu',
  departure_date_capital: 'Termin wylotu',
  arrival_date: 'termin przylotu',
  arrival_date_capital: 'Termin powrotu',
  flight_number: 'nr lotu',
  airline: 'linia lotnicza',
  adults_number: 'Liczba dorosłych:',
  children_number: 'Liczba dzieci:',
  children_age: 'Wiek dzieci:',
  chosen_directions: 'Wybrane kierunki:',
  destinations: 'Kierunki',
  chosen: 'Wybrano',
  destination: 'kierunek',
  destinations_first_plural: 'kierunki',
  destinations_second_plural: 'kierunków',
  option: 'opcję',
  options_first_plural: 'opcje',
  options_second_plural: 'opcji',
  selected_airports: 'Wybrane lotniska:',
  airport: 'lotnisko',
  airports_first_plural: 'lotniska',
  airports_second_plural: ' lotnisk',
  popular: 'Popularne',
  germany: 'Niemcy',
  poland: 'Polska',
  other: 'Inne',
  airports: 'Lotniska',
  no_airports: 'Brak lotnisk',
  no_reviews: 'brak ocen',
  good: 'dobry',
  'very-good': 'bardzo dobry',
  excellent: 'świetny',
  splendid: 'wspaniały',
  magnificent: 'wyjątkowy',
  example_email: 'przykladowy@email.pl',
  check: 'sprawdź',
  checking: 'Sprawdzam',
  offer_unavailable: 'Oferta niedostępna',
  cheapest: 'Najtaniej!',
  no_element: 'Brak elementu',
  departure_place: 'Wylot z',
  more_dates: 'Więcej terminów i cen',
  no_available_offers: 'Brak dostępnych ofert',
  no_operators: 'Brak organizatorów',
  one_operator_selected: 'organizatora',
  operators_first_plural: 'organizatorów',
  operators_second_plural: 'organizatorów',
  person_shortcut: 'os.',
  to: 'do',
  days_count: 'Liczba dni:',
  choose_option: 'Wybierz opcję',
  all_inclusive: 'All inclusive',
  first_minute: 'First minute',
  last_minute: 'Last minute',
  invalid_content: 'Niepoprawna zawartość',
  see_all: 'Zobacz wszystkie',
  generate_offers_in_pdf: 'Wygeneruj oferty w pdf',
  delete_all: 'usuń wszystkie',
  send_cupboard_to_email: 'Wyślij schowek na email',
  delete_from_cupboard: 'Usuń ze schowka',
  prices_and_dates_loading: 'Ładowanie terminów i cen..',
  cupboard: 'Schowek',
  no_offers_in_cupboard: 'Brak ofert w schowku',
  departure_from_day: 'Wyjazd od dnia',
  arrival_to_day: 'Powrót do dnia',
  choose_operator: 'wybierz operatora',
  loading_offer_options: 'Ładowanie wariantów oferty..',
  type: 'Typ',
  less_options: 'Mniej opcji',
  more_options: 'Więcej opcji',
  other_accommodation_options: 'Inne opcje zakwaterowania i wyżywienia',
  together: 'razem',
  adult: 'dorosły',
  adults_selected_plural: 'dorosłych',
  child: 'dziecko',
  children_selected_plural: 'dzieci',
  hotel_placement_map: 'Mapa umiejscowienia hotelu',
  domain_name: 'wakacjeamigos.pl',
  sorry_offer_is_unavailable:
    'Przepraszamy, oferta nie jest już dostępna. Prosimy wybrać inną ofertę.',
  sorry_error_occured:
    'Przepraszamy, wystąpił błąd. Prosimy odświeżyć stronę lub wybrać inną ofertę.',
  price_per_person: 'Cena za osobę',
  maximal_price_eur: 'Maksymalna cena za osobę w euro',
  hotel_standard: 'Standard hotelu',
  hotel_standard_from: 'Standard hotelu od',
  operator_name: 'Nazwa organizatora',
  operator_short: 'organiz.',
  hide_prices: 'Ukryj terminy i ceny ',
  do_you_know: 'Czy wiesz, że...',
  one_more_moment: 'Jeszcze moment!',
  looking_for_best_offers: 'Właśnie szukamy dla Ciebie najlepszych ofert!',
  found_offers: 'Znalezione oferty: ',
  invalid_date_format: 'Nieprawidłowy format daty. Wpisz DD.MM.RRRR',
  man: 'Mężczyzna',
  woman: 'Kobieta',
  transfer: 'Przelew',
  cash: 'Gotówka',
  card: 'Karta',
  payment_on_airport: 'Płatność na lotnisku',
  no_destinations: 'Brak kierunków',
  all_directions: 'Wszystkie Kierunki',
  insurance_lowercase: 'ubezpieczenie',
  insurance_price: 'Opłata za ubezpieczenie',

  //OFFER TYPES
  hotel_only: 'Hotel',
  hotels: 'Hotele',
  only_hotels: 'Tylko hotele',
  holiday: 'Wakacje',
  trip: 'Wycieczka',
  cruise: 'Rejs',
  one_way_flight: 'Lot w jedną stronę',
  two_ways_flight: 'Lot w dwie strony',
  flight_tickets: 'Bilety lotnicze',
  group_reservations: 'Wycieczki grupowe',
  group_reservations_short: 'Grupowe',
  //NEWSLETTER SECTION
  your_email_address: 'Twój adres email',
  sign_up: 'Zapisz się',
  rodo_info:
    'Zgodnie z ustawą z dnia 18.07.2002 r. o świadczeniu usług drogą elektroniczną (Dz.U. Nr 144, poz.1204 z późn. zm.) zapisując się na newsletter wyrażasz zgodę na przesyłanie informacji handlowych drogą elektroniczną przez Biuro Podróży Amigos B.B Sp z o.o w Jeleniej Górze',
  signed_up: 'Dziękujemy za zapisanie się do naszego newslettera',
  invalid_email_message:
    'E-mail musi być w formacie email@przyklad.pl, lub j_kowal.nowak@przyklad.com.pl, bez polskich znaków',
  //HOTEL DESCRIPTIONS SECTION
  export_to_pdf: 'Eksportuj do PDF',
  countries: 'Kraje',
  regions: 'Regiony',
  categories: 'Kategorie',
  all: 'Wszystkie',
  filter: 'Filtruj',
  filter_results: 'Filtruj wyniki',
  base_data: 'Dane podstawowe',
  operators: 'Operatorzy',
  original_description: 'Oryginalny opis',
  description_translated: 'Opis tłumaczony przez google',
  loading: 'Ładowanie...',
  description: 'Opis',
  descriptions: 'Opisy',
  excluding_owner: 'Bez opisów Amigos',
  only_owner: 'Tylko z opisem Amigos',
  show_offer_variants: 'Pokaż inne terminy i ceny',
  hide_offer_variants: 'Zwiń terminy i ceny',
  show_dates_with_prices: 'Pokaż terminy i ceny',
  go_to_description: 'Zobacz opis',
  terms_and_prices: 'Terminy i ceny',
  check_offer: 'Sprawdź dostępność',
  show_map: 'Pokaż mapę',
  facilities: 'Udogodnienia',
  facilities_list: 'Lista udogodnień',
  show_gallery: 'Pokaż galerię',
  show_flight_details: 'Pokaż szczegóły lotów',
  flights_details: 'Szczegóły lotu',
  aditional_info: 'Informacje dodatkowe',
  book_offer: 'Zarezerwuj ofertę',
  hotel_reviews: 'Opinie o hotelu',
  show_hotel_reviews: 'Pokaż opinie o hotelu',
  hotel_location: 'Położenie hotelu',
  gallery: 'Galeria',
  equipment_and_facilities: 'Wyposażenie i udogodnienia',
  contact_and_localization: 'Kontakt i lokalizacja',
  contact_informations: 'Informacje kontaktowe',
  inside_hotel: 'W hotelu',
  inside_rooms: 'W pokojach',
  additional_attractions: 'Dodatkowe atrakcje',
  localization: 'Lokalizacja',
  about_hotel: 'O hotelu',
  change_description_provider: 'Zmień opis operatora',
  description_is_translated:
    'Oglądasz teraz oryginalny opis oferty przetłumaczony przez Google Translate TM',
  description_is_original:
    'Oglądasz teraz oryginalny opis oferty dostarczony przez operatora ',
  show_translation: 'przetłumacz na język polski',
  show_original_text: 'pokaż oryginalny tekst',
  an_error_has_occurred:
    'Wystąpił nieoczekiwany błąd opisu. Prosimy odświeżyć stronę.',
  show_more: 'Pokaż więcej',
  show_less: 'Pokaż mniej',
  explanation_mark: 'Wykrzyknik',
  providers_description_explanation:
    'Oryginalny opis operatora występuje w języku niemieckim ale dla Twojej wygody możesz przetłumaczyć go za pomocą automatycznego translatora. Jeśli masz jakiekolwiek wątpliwości zapraszamy do kontaktu pod numerem telefonu ',
  providers_description_explanation_not_translatable:
    'Jeśli masz jakiekolwiek wątpliwości zapraszamy do kontaktu pod numerem telefonu ',
  or_email: ', mailem: ',
  or_ask_about_offer: ', lub używając przycisku Zapytaj o ofertę.',
  call_us_phone: 'Zadzwoń - Telefon stacjonarny',
  about_description_provider:
    'opis stanowi tylko ogólną informację o ofercie, dokładny opis wycieczki znajduje się zawsze przy złożeniu oferty',
  why_from_germany: 'Dlaczego z Niemiec?',
  why_from_germany_link_title:
    'Przeczytaj dlaczego warto podróżować z Niemieckimi operatorami',

  // ADMIN SPECIAL OFFERS
  admin_special_offers_supplier: 'Dostawca',
  admin_special_offers_duration: 'Długość pobytu',
  offer_type: 'Typ oferty',
  hotel_name: 'Nazwa hotelu lub oferty',
  offer_search_empty: 'Brak wyników wyszukiwania',
  searching_in_progress: 'Wyszukiwanie...',

  //ADMIN infoboxes
  activity_changed: 'Zmieniono aktywność infoboxów.',
  activity_change_error:
    'Wystąpił błąd podczas zmiany aktywności. Proszę spróbować ponownie.',

  //RESERVATIONS SECTION
  //ContactForm
  sign_to_newsletter: 'Zapisz mnie do newslettera',
  send_message: 'Wyślij wiadomość',
  full_name: 'Imię i nazwisko',
  full_name_notification:
    'Tekst nie może być krótszy niż 3 znaki. Nie może zawierać cyfr',
  email_address: 'Adres e-mail',
  email_notification:
    'Email musi być w formacie email@przyk.com, email_pol@przyk.pl',
  phone_number: 'Numer telefonu',
  phone_number_notification: 'Telefon powinien zawierać od 7 do 15 cyfr',
  message_content: 'Treść wiadomości',
  message_content_notification:
    'Wiadomość nie może być krótsza niż 3 i dłuższa niż 2000 znaków',
  people_count: 'Liczba osób',
  additional_comments: 'Dodatkowe uwagi',
  preferred_airport: 'Dogodne lotnisko wylotu',
  agreement_rules:
    'Zapoznałem się z Regulaminem oraz Polityką prywatności i akceptuję ich postanowienia',
  agreement_send:
    'Zgadzam się, na przesyłanie informacji handlowych na podany adres poczty elektronicznej w imieniu własnym i innych podmiotów. Zgoda jest dobrowolna i mogę cofnąć ją w dowolnym momencie. Więcej informacji o tym jak przetwarzamy Twoje dane osobowe oraz jak skorzystać z przysługujących Ci praw, znajdziesz w naszej Polityce Prywatności.',
  must_accept_agreement: 'Zgoda jest wymagana, by kontynuować',
  //Send offer by mail
  your_email: 'Podaj email...',
  send_offer_to_mail: 'Wpisz email i wyślij ofertę',
  ask_us_about_offer: 'Zapytaj o ofertę',
  click_to_send: 'Kliknij aby wysłać',
  email_pending: 'Wysyłanie...',
  offer_sent: 'Oferta została wysłana',
  offer_send_error: 'Wystąpił błąd',
  offer_mail_invalid: 'Podany mail jest niepoprawny',
  //Send cupboard by mail
  remove_all_favourites: 'Usuń wszystkie elementy',
  favourites_removed: 'Usunięto wszystkie elementy',
  favourites_no_data: 'Brak elementów do wysłania',
  send_favourites_to_mail: 'Wyślij schowek mailem',
  send_favourites_to_mail_pdf: 'Wyślij oferty w pdf',
  favourites_sent: 'Schowek została wysłany',
  remove_all_favourites_elements: 'Usunąć wszystkie elementy?',
  yes: 'tak',
  no: 'nie',
  //Ask for an offer
  form_title: 'Zapytaj nas o ofertę',
  sub_title: 'Odpowiemy najszybciej, jak to możliwe',
  message_is_sent: 'Wiadomość została wysłana',
  message_is_sent_content:
    'Dziękujemy za wiadomość. Wkrótce odpowiemy na Twoje pytania.',
  close: 'Zamknij',
  ask_for_offer_name: 'Zapytaj o tę ofertę',
  //Add to favourites
  add_to_favourites: 'Dodaj do schowka',
  added_to_favourites: 'Dodano do schowka',
  favourites_error: 'Błąd zapisu do schowka',
  favourites_warning: 'Opcja nie jest dostępna w Twojej przeglądarce',
  go_to_offer: 'Przejdź do oferty',
  see_description: 'Zobacz opis',
  //ReservationForm
  reservation_form_title: 'Zamówienie wstępne',
  reservation_form_title_agent: 'Zarezerwuj jako Agent',
  about_reservation_cost:
    'Wypełnienie formularza nie wiąże się z żadnymi kosztami',
  about_contact_with_client:
    'Nasz doradca skontaktuje się z Państwem w celu potwierdzenia rezerwacji i ustalenia szczegółów płatności.',
  about_payments_and_insurance:
    'Rezerwacja bez płatności nie gwarantuje stałości ceny. Do ceny wycieczki nie zostały naliczone koszty obowiązkowego  ubezpieczenia turystycznego. Stawki składek obowiązkowego  ubezpieczenia turystycznego określa rozporządzenie Ministra Sportu i Turystyki z dnia 21 listopada 2016 r. w sprawie wysokości składki na Turystyczny Fundusz Gwarancyjny.',
  agent_form_description:
    'Wypełnienie formularza utworzy przypisaną do Ciebie pozycję rezerwacji w panelu administracyjnym',
  first_name: 'Imię',
  client_first_name: 'Imię Klienta',
  last_name: 'Nazwisko',
  client_club: 'Klub Klienta',
  client_last_name: 'Nazwisko Klienta',
  client_email_address: 'Adres email Klienta',
  client_phone_number: 'Numer telefonu Klienta',
  annotations: 'Uwagi',
  total_price: 'Cena łączna',
  send_reservation: 'Rezerwacja Wstępna',
  send_reservation_and_pay: 'Zarezerwuj i zapłać',
  send_agent_reservation: 'Zarezerwuj jako agent',
  pay_now_reservation:
    'Ceny mogą się zmienić. Kup od razu aby mieć gwarancję ceny!',
  processing_personal_data:
    '*Wyrażam zgodę na przetwarzanie danych osobowych przez firmę Amigos B.B. Sp z o.o. zawartych w formularzu w celach związanych z obsługą zamówienia.',
  rodo_information_1: 'Więcej szczegółów w dokumencie dotyczącym ',
  rodo_information_2: 'przetwarzania danych osobowych.',
  pln: 'zł',
  euro: '€',
  accept_operator_condition: '*Zgadzam się na ',
  accept_operator_condition_link_text: 'warunki operatora',
  sending: 'Wysyłanie',
  thank_you_for_reservation:
    'Dziękujemy za dokonanie rezerwacji wstępnej. Podsumowanie zostało przesłane na email podany w formularzu. Nasz konsultant niebawem skontaktuje się z Tobą.',
  thank_you_for_reservation_insurance:
    'Dziękujemy za dokonanie rezerwacji wstępnej. Podsumowanie i informacje dotyczące zapłaty za ubezpieczenie zostały przesłane na email podany w formularzu. Nasz konsultant niebawem skontaktuje się z Tobą.',
  thank_you_for_reservation_agent:
    'Rezerwacja zapisana poprawnie. Przejdź do panelu aby utworzyć umowę do tej rezerwacji.',
  newsletter_after_sign_up:
    'Na Twoją skrzynkę w ciągu kilku minut przyjdzie mail z linkiem do potwierdzenia subskrypcji, kliknij go, jeśli chcesz otrzymywać od nas wiadomości.',
  checkbox_acceptance_error: 'To pole jest wymagane',
  show_reservation: 'Idź do rezerwacji',
  show_reservations: 'Pokaż wszystkie rezerwacje',
  reservation_insurance: 'Ubezpieczenie podróży',
  no_insurance: 'Bez ubezpieczenia',
  insurance_cover: 'Zakres ubezpieczenia',
  insurance_sum: 'Suma ubezpieczenia',
  agree_to_insurance:
    '*Zapoznałem się z ogólnymi warunkami Ubezpieczenia i wyrażam zgodę na przetwarzanie danych osobowych przez firmę Signal Iduna',
  choose_insurance_cover: 'Wybierz zakres:',
  polish_insurance: 'Polski ubezpieczyciel',
  german_insurance: 'Niemiecki ubezpieczyciel',
  PLN: 'zł',
  EUR: '€',
  invalid_form_content:
    'Niepoprawnie wypełniony formularz rezerwacji. Popraw dane i spróbuj ponownie.',

  // Favourites
  search_box_title: 'Spełnij swoje słoneczne marzenie',
  search_box_emphasis: 'Wyszukaj idealną wycieczkę',
  search_box_search_button: 'Wyszukaj ofertę',
  // Main Page filters
  filters_any: 'dowolny',
  filters_any_plural: 'dowolne',
  // Logged in infobox
  logged_in_msg: 'Jesteś obecnie zalogowany',
  //Common
  offers: 'Oferty',
  from: 'od',
  no_offers: 'Brak ofert',
  system_error: 'Błąd systemu',
  main_page: 'Strona główna',
  offers_list: 'Lista ofert',
  no_offers_found:
    'Hmm, nie znaleźliśmy ofert przy wybranych przez Ciebie parametrach.',
  dont_be_worried:
    'Ale nie przejmuj się! Mamy ich jeszcze ponad 860 tysięcy. <br> Zmień wyniki wyszukiwania lub sprawdź popularne kierunki: <br> <a href="/wakacje/dominikana" title="wakacje na Dominikanie" >Dominikana</a> <a href="/wakacje/turcja" title="wakacje w Turcji" >Turcja</a> <a href="/wakacje/grecja" title="wakacje w Grecji" >Grecja</a> <a href="/wakacje/hiszpania" title="wakacje w Hiszpanii" >Hiszpania</a> <a href="/wakacje/kuba" title="wakacje na Kubie" >Kuba</a>',
  change_filters: 'Zmień parametry wyszukiwania',
  offers_list_error: 'Niestety, przepraszamy wystąpił błąd :( ',
  days: 'dni',
  refresh_page: 'Proszę odświeżyć stronę lub spróbować ponownie później.',
  contact_us: 'Skontaktuj się z nami',
  or: ' lub ',
  flight_interchanges_info:
    'Dodatkowe informacje o przesiadkach lotów, dostarczone przez operatora',
  flight_basic_info: 'Podstawowe informacje o lotach',
  interchange: 'przesiadka',
  interchanges_included: 'Przelot zawiera przesiadki',
  //Zoover rating
  accommodation: 'Zakwaterowanie',
  board: 'Wyżywienie',
  overall: 'Całość',
  price_quality: 'Cena',
  service: 'Obsługa',
  total_reviews: 'liczba opinii',
  attractions: 'Atrakcje',
  location: 'Położenie',
  reviews_provider: 'oceny wakacji',
  review1: 'opinia',
  review2: 'opinie',
  review3: 'opinii',
  read_more: 'Rozwiń',
  read_less: 'Zwiń',
  transfer_title: 'Transfer',
  with_transfer: 'Z transferem',
  without_transfer: 'Bez transferu',
  //weather
  weather: 'pogoda',
  weather_graphs_title: 'Średnie dane pogodowe z podziałem na miesiące',
  // weather - graphs - legends
  celsius_temperature: 'Temperatura w °C',
  day: 'dzień',
  night: 'noc',
  water_celsius_temperature: 'Temperatura wody °C',
  sunny_hours_per_day: 'Liczba słonecznych godzin w ciągu dnia',
  rainy_days_per_month: 'Liczba deszczowych dni w miesiącu',
  // weather widget
  widget_description:
    'Średnia temperatura powietrza i wody w wybranym miesiącu.',

  // home page
  hotel_name_filter: 'Nazwa hotelu',
  offer_expired_1:
    'Niestety, wygląda na to, że ta oferta została już przez kogoś zarezerwowana.',
  offer_expired_2: ' Sprawdź inne terminy i ceny',
  offer_expired_3: 'w ',

  //seo offers list
  seo_offers_list: 'Lista ofert',
  seo_region_information: 'Informacje o regionie',
  seo_practical_information: 'Informacje praktyczne',
  seo_map: 'Mapa',
  no_offers_contact_form_header:
    'Nie masz czasu na szukanie wycieczki? <br> Nasi specjaliści zrobią to za Ciebie!',
  no_more_offers_contact_form_header:
    'To już wszystkie dostępne oferty. Interesuje Cię ten hotel? Skontaktuj się z nami, a dopasujemy najlepszy&nbsp;termin&nbsp;i&nbsp;cenę.',
  no_offers_contact_form_description:
    'Zostaw swój email a my skontaktujemy się z Tobą. Telefon jest opcjonalny.',
  no_offers_contact_form_error: 'Podaj swój adres email.',
  no_offers_contact_form_button: 'Znajdźcie dla mnie najlepsze wakacje',
  no_offers_contact_form_message_send_header: 'Dziękujemy',
  no_offers_contact_form_message_send_description:
    'Nasi specjaliści skontaktują się z Tobą w najszybszym możliwym czasie. <br> Biuro pracuje od poniedziałku do piątku w godzinach 9 - 17, w soboty nieczynne.',
  no_offers_contact_form_rodo_information:
    'Zgodnie z ustawą z dnia 18.07.2002 r. o świadczeniu usług drogą elektroniczną (Dz.U. Nr 144, poz.1204 z późn. zm.) zgłaszając prośbę o kontakt wyrażasz zgodę na przesyłanie informacji handlowych drogą elektroniczną oraz otrzymywanie telefonicznych połączeń przychodzących w celu pomocy w doborze oferty zgodnie z art. 172 ustawy prawo telekomunikacyjne przez Biuro Podróży Amigos B.B Sp z o.o w Jeleniej Górze.',
  send: 'Wyślij',
  click_to_change: 'Kliknij aby zmienić',
  press_enter_to_save:
    'Wciśnij Enter aby zapisać, kliknij obok aby porzucić zmiany',
  error_occurred_during_save: 'Błąd zapisu spróbuj jeszcze raz',
  action_save: 'Zapisz',
  action_cancel: 'Anuluj',
  action_edit_note: 'Edytuj notatkę',
  action_create_note: 'Stwórz notatkę',

  // German operators advantages banner
  why_holidays: 'DLACZEGO WAKACJE',
  with_german_operator: 'Z NIEMIECKIM OPERATOREM?',
  tours_with_german_operator_is_awesome:
    'Wycieczki z operatorem niemieckim to same plusy!',
  our_clients_know_that_already:
    'Nasi stali Klienci już to wiedzą. Rezerwuj wycieczki z&nbsp;Niemiec u&nbsp;nas i&nbsp;ciesz się swoimi wymarzonymi wakacjami.',
  cheaper_holidays:
    'wakacje są <b>tańsze nawet&nbsp;o&nbsp;40%</b><br>płatność w <b>euro</b> lub <b>złotówkach</b>',
  cheaper_holidays_title: 'Tańsze wakacje',
  cheaper_holidays_alt: 'Świnka skarbonka',
  protected_holidays: 'Twój wyjazd jest lepiej <b>chroniony</b>',
  protected_holidays_title: 'Wyjazdy są lepiej chronione',
  more_requirements:
    'operatorzy muszą spełnić więcej wymagań, aby&nbsp;móc organizować wycieczki',
  protected_holidays_alt: 'Wyjazd chroniony',
  better_quality: 'otrzymujesz zawsze <b>lepszej jakości pokój</b>',
  better_quality_title: 'Pokoje i wyżywienie lepszej jakości',
  better_quality_alt: 'Hotel pięciogwiazdkowy',
  compliance_with_description:
    'hotel zawsze <b>zgodny z&nbsp;opisem</b> oraz <b>gwarancja niezmienności ceny</b>',
  compliance_with_description_title: 'Hotele zgodne z opisem',
  compliance_with_description_alt: 'Zgodność z umową',
  more_destinations:
    '<b>szersza oferta</b> kierunków i&nbsp;terminów oraz <b>nowoczesne, komfortowe samoloty</b>',
  more_destinations_title: 'Więcej terminów i kierunków',
  more_destinations_alt: 'Kierunki podróży',

  // German operators - flights from germany
  why_with_german_operator_alt:
    'Sprawdź dlaczego warto podróżować z Niemieckim operatorem',
  why_holidays_with_german_operator:
    'Dlaczego wakacje z Niemieckim operatorem?',
  lower_prices: 'wakacje są tańsze nawet o 40%',
  better_rooms: 'w cenie otrzymujesz zawsze lepszej jakości pokój',
  better_safety:
    'Twój wyjazd jest lepiej chroniony (operatorzy muszą spełnić więcej wymagań aby móc organizować wycieczki)',
  always_consistent: 'hotel zawsze zgodny z opisem',
  more_destinations_and_dates: 'szersza oferta kierunków i terminów',

  // Common
  office_phone_number: '+48&nbsp;75&nbsp;753&nbsp;26&nbsp;01',
  office_phone_number_no_spaces: '+48757532601',
  office_email: 'rezerwacje@wakacjeamigos.pl',

  //Admin - contract panel
  save_contract: 'Zapisz',
  generate_agreement: 'Generuj umowę',
  close_agreement: 'Zakończ umowę',
  reopen_agreement: 'Otwórz umowę',

  agreement_notes: 'Notatki',
  close_button_hint_text:
    'Oznacz umowę jako zamkniętą i gotową do dalszego przetwarzania.',
  reopen_button_hint_text: "Zmień status umowy na 'w przygotowaniu'",
  //tabs names
  tab_agreement: 'Kontrakt',
  tab_clients: 'Osoby',
  tab_travel: 'Podróż',
  tab_payments: 'Płatności',
  tab_send_documents: 'Wyślij',
  tab_history: 'Historia',
  tab_register_receipts: 'KP',
  //sections
  agreement: 'Umowa',
  agent: 'Agent',
  representative: 'Pośrednik',
  operator: 'Organizator',
  client: 'Zawierający umowę',
  participants_data: 'Dane uczestników',
  travel: 'Podróż',
  transportation: 'Transport',
  accommodation_and_alimentation: 'Hotel i wyżywienie',
  additional_information: 'Informacje dodatkowe',
  summary: 'Podsumowanie',
  payments: 'Płatności',
  kind_of_payment: 'Rodzaje płatności',
  send_documents_to_client: 'Wyślij dokumenty jako załączniki do klienta',
  send_insurances: 'Wyślij ubezpieczenia do ubezpieczyciela',
  history_of_changes: 'Historia zmian',
  additional_documents: 'Dołącz wybrane pliki do umowy',
  office_documents: 'Dokumenty amigos',
  operators_documents: 'Dokumenty operatorów',
  contract_additional_files: 'Pliki dodane do umowy',
  payments_accounts_numbers: 'Numery kont',
  history_of_documents_send: 'Historia wysłanych dokumentów',
  //inputs
  contract_agreement_date: 'Data zawarcia umowy',
  contract_agreement_place: 'Miejsce zawarcia umowy',
  contract_agreement_type: 'Typ rezerwacji',
  contract_agreement_status: 'Status umowy',
  contract_etax_number: 'Numer etax',

  contract_office_name: 'Nazwa biura',
  contract_office_address: 'Adres biura',
  contract_office_city: 'Miasto',
  contract_agent_name: 'Imię',
  contract_agent_surname: 'Nazwisko',
  contract_agent_email: 'Email',
  contract_agent_phone: 'Telefon',

  contract_representative_name: 'Nazwa',
  contract_representative_address: 'Adres',
  contract_representative_person: 'Reprezentant',
  contract_representative_krs: 'KRS',
  contract_representative_nip: 'NIP',

  contract_operator_name: 'Nazwa operatora',
  contract_operator_code: 'Kod operatora',
  contract_operator_reservation_number: 'Numer rezerwacji',

  clients_gender: 'Płeć',
  clients_surname: 'Nazwisko',
  clients_name: 'Imię',
  clients_pesel: 'Pesel',
  clients_phone: 'Telefon',
  clients_country: 'Państwo',
  clients_address_code: 'Kod pocztowy',
  clients_city: 'Miasto',
  clients_address: 'Adres',
  clients_email: 'Email',
  clients_date_of_birth: 'Data urodzenia',
  clients_currency: 'Waluta',
  clients_reservation_price: 'Cena rezerwacji',
  clients_cancelation_insurance_price: 'Ubezp. rezygnacji: kwota',
  clients_cancelation_insurance_percent: 'Ubezp. rezygnacji: %',
  clients_interuption_insurance_price: 'Ubezp. przerwania: kwota',
  clients_interuption_insurance_percent: 'Ubezp. przerwania: %',
  clients_compulsory_insurance: 'Ubezpieczenie obowiązkowe',
  clients_tfg: 'Turystyczny fundusz gwarancyjny',
  clients_additional_insurance: 'Ubezpieczenie dodatkowe',
  clients_add_last_participants_button:
    'Przenieś dane uczestników z poprzedniej umowy',
  clients_insurance: 'Ubezpieczenie',

  register_receipts_type: 'Rodzaj',
  register_receipts_date: 'Data',
  register_receipts_show_for_client: 'Pokaż (dla klienta)',
  register_receipt_types_advance: 'Zaliczka',
  register_receipt_types_total: 'Całość',
  register_receipt_new: 'Wystaw',
  register_receipt_number: 'Numer',

  travel_destination: 'Destynacja',
  travel_departure: 'Wyjazd',
  travel_arrival: 'Powrót',
  travel_time_period: 'Liczba dni',
  travel_insurance_from: 'Okres ubezpieczenia od:',
  travel_insurance_to: 'Okres ubezpieczenia do:',

  travel_reservation_type: 'Rodzaj rezerwacji',
  travel_departure_arrival_airport: 'Wyjazd: lotnisko przylotu',
  travel_date: 'Data',
  travel_hour: 'Godzina',
  travel_arrival_airport: 'lotnisko przylotu',
  travel_departure_airport: 'lotnisko wylotu',
  travel_departure_place_verb: 'Wyjazd',
  travel_arrival_place_verb: 'Powrót',
  travel_contact_point: 'miejsce zbiórki',

  accommodation_city: 'Miasto',
  accommodation_hotel_name: 'Nazwa hotelu',
  accommodation_standard: 'Standard',
  accommodation_type: 'Zakwaterowanie',
  accommodation_alimentation_type: 'Rodzaj wyżywienia',
  additional_information_templates: 'Szablony informacji dodatkowych',

  payments_receiver: 'Odbiorca płatności',
  payments_method: 'Sposób płatności',
  disabled_unsaved_button_title: 'Zapisz zmiany aby kontynuować.',
  disabled_external_contract_not_attached:
    'Umowa nie może zostać zamknięta bez dołączonej umowy niemieckiej',
  disabled_agent_not_allowed_to_reopen_contract:
    'Nie możesz otworzyć zamkniętej umowy. Skontaktuj się z biurem amigos',
  disabled_contract_not_ready_to_be_saved: 'Uzupełnij wszystkie brakujące dane',

  payments_summary_cancellation_insurance: 'Ubezp. od kosztów rezygnacji',
  payments_summary_interuption_insurance: 'Ubezp. od kosztów przerwania',
  payments_summary_tfg: 'Turyst. Fundusz Gwarancyjny:',
  payments_summary_compulsory_insurance: 'Ubezpieczenia obowiązkowe:',
  payments_summary_additional_insurance: 'Ubezpieczenia dodatkowe:',
  payments_summary_reservations_sum: 'Całkowita suma rezerwacji uczestników',
  payments_summary_insurances_sum: 'Całkowita suma ubezpieczeń:',
  payments_summary_type: 'Wybierz termin płatności',
  payments_insurance_set: 'Ubezpieczenie rozliczone',
  payment_pln_sum: 'Kwota w PLN',
  payment_eur_sum: 'Kwota w EUR',
  payments_all_date: 'Data',
  payments_advance_day: 'Zaliczka w dniu:',
  payments_advance_rest_day: 'Dopłata do dnia:',
  payments_advance: 'Zaliczka: ',
  payments_advance_percent: 'Zaliczka [%]',
  payments_advance_rest: 'Dopłata',
  payments_all_sum: 'Całość',

  documents_client_email: 'Email klienta (adresata)',
  documents_client_email_text_message: 'Treść wiadomości',
  //errors
  contract_cannot_be_blank: 'Pole nie może być puste',
  constract_not_valid_reservation_number: 'Podaj prawidłowy numer rezerwacji',
  add_client_to_participants: 'Dodaj do uczestników',
  add_participant: 'Dodaj uczestnika',
  dates_cannot_be_blank: 'Uzupełnij daty wyjazdu i powrotu',
  dates_order_not_valid: 'Nieprawidłowa kolejność dat',
  pesel_number_should_have_valid_length: 'Nieprawidłowy nr pesel',
  email_should_be_valid: 'Nieprawidłowy adres email',
  percent_invalid_format: 'Nieprawidłowa wartość',
  price_invalid_format: 'Nieprawidłowa kwota',
  attachment_cannot_be_larger_than:
    'Wielkość załączników nie może przekroczyć 25MB! Klient nie otrzyma wiadomości.',

  history_person_modified: 'Osoba',
  history_type_change: 'Akcja',
  history_change_date: 'Data',
  created: 'Utworzenie umowy',
  modified: 'Modyfikacja',
  exported_to_pdf: 'Eksport do pdf',
  document_uploaded: 'Dodanie pliku',
  document_deleted: 'Usunięcie pliku',
  email_sent: 'E-mail wysłany',
  insurance_email_sent: 'Wysłano zestawienie ubezpieczeń',
  failed_to_send_insurance_email: 'Zestawienie ubezpieczeń błąd wysyłki',
  failed_to_send_email: 'E-mail błąd wysyłki',
  contract_finalized: 'Zmieniono status na "Zamknięta"',
  contract_set_to_pending: 'Zmieniono status na "W przygotowaniu"',
  history_field_name: 'Nazwa pola',
  history_field_before_change: 'Przed zmianą',
  history_field_after_change: 'Po zmianie',
  send_history_filename: 'Nazwa pliku',
  history_header: 'Historia wysyłek ubezpieczeń (V/X)',
  history_insurance_name: 'Nazwa ubezpieczenia',
  history_insurance_sent: 'Czy zostało wysłane(V/X)?',
  history_cancellation_insurance: 'Ubezpieczenie od kosztów rezygnacji',
  history_interuption_insurance: 'Ubezpieczenie od kosztów przerwania',
  history_compulsory_insurance: 'Ubezpieczenia obowiązkowe',
  history_additional_insurance: 'Ubezpieczenia dodatkowe',
  history_cancellation_insurance_short: 'KR',
  history_interuption_insurance_short: 'KP',
  history_compulsory_insurance_short: 'Obowiązkowe',
  history_additional_insurance_short: 'Dodatkowe',
  history_insurance_date: 'Data wysyłki',

  insurances_emails_already_sent:
    'Ubezpieczenie dla wybranej umowy było już wysyłane!',
  insurances_confirm_send:
    'Ubezpieczenie dla wybranej umowy było już wysyłane do ubezpieczyciela. Czy mimo to chcesz kontynuować?',
  insurances_send_contract: 'Wyślij ubezpieczenie',
  insurances_send_contract_without_cancellation:
    'Wyślij ubezpieczenie (bez ub. od kosztów rezygnacji)',

  documents_add_additional_files: 'Dołącz dodatkowe pliki do umowy',
  documents_add_external_contract_file: 'Dodaj plik niemieckiej umowy',
  documents_send_contract: 'Wyślij dokumenty',
  documents_abort_sending: 'Anuluj',

  drag_and_drop_max_size_hint: 'Maksymalny rozmiar wszystkich załączników',
  drag_and_drop_disabled_text: 'Zapisz umowę żeby dodać pliki.',
  documents_message_send_password: 'Wysłano! Hasło do umowy: ',
  documents_email_message_not_send: 'Błąd, wiadomość nie została wysłana',
  documents_remember_to_save_contract:
    'Pamiętaj aby zapisać umowę przed wysłaniem jej do klienta!',

  remove_file_title: 'Usuń plik',
  file_encrypted: 'Plik szyfrowany hasłem',
  documents_drag_and_drop_additional_hint:
    'Pliki zostaną dołączone do zaszyfrowanej umowy.',
  documents_summary_email: 'Adres email',
  documents_summary_content: 'Treść wiadomości',
  documents_summary_documents: 'Lista dokumentów',
  documents_summary_total_documents_weight: 'Suma załączników',
  documents_summary_contract: 'Umowa',

  // SETTLEMENTS
  settlements_filter: 'Pokaż',
  settlements_filter_export_option: 'Rodzaj eksportu',
  settlements_filter_date_to: 'Data {date_attribute} do',
  settlements_filter_date_from: 'Data {date_attribute} od',
  date_attribute_departure_date: 'wyjazdu',
  date_attribute_return_date: 'powrotu',
  date_attribute_contract_date: 'umowy',
  date_attribute_insurances_sent_date: 'wysł. ubezp.',
  settlements_filter_title: 'Wciśnij przycisk aby zobaczyć umowy do eksportu',
  settlements_filter_status_all: 'Wszystkie',
  settlements_filter_agent_label: 'Agentura',
  settlements_filter_agent_all: 'Agentury + Amigos',
  settlements_export: 'Eksportuj do .xlsx',
  settlements_export_title: 'Wciśnij przycisk aby pobrać plik xlsx',

  //OFFERS COLLECTION
  offers_collection_index_header: 'Wyszukiwanie ofert',
  choose_a_region: 'Wybierz region',
  choose_airports: 'Wybierz lotniska',
  choose_operators: 'Wybierz operatorów',
  adults_count: 'Dorośli',
  children_count: 'Dzieci',
  min_standard: 'Standard od',
  missing: 'brak',
  trip_length: 'Czas pobytu',
  trip_length_from: 'Pobyt od',
  trip_length_days: '(dni)',
  trip_length_to: 'Pobyt do',
  max_price_eur: 'Maksymalna cena',
  euro_per_person: '(EUR/os.)',
  chosen_regions: 'Wybrane regiony',
  chosen_airports: 'Wybrane lotniska',
  chosen_operators: 'Wybrani operatorzy',
  hotels_per_region: 'Liczba hoteli na region',
  parser_list: 'Źródło',
  flex_types: 'Oferta Flex',
  located_list: 'Lokacja',
  search: 'Wyszukaj',
  not_chosen: 'Nie wybrano',
  columns_in_table: 'Kolumny w tabeli',
  offers_collection_region: 'Region',
  offers_collection_hotel_name: 'Hotel',
  offers_collection_flight_departure: 'Wylot',
  offers_collection_city: 'Miejscowość',
  offers_collection_flight_arrival: 'Przylot',
  offers_collection_stars: '*',
  offers_collection_ratings: 'Ocena',
  offers_collection_operator: 'Organ.',
  offers_collection_price: 'Cena',
  offers_collection_departure_date: 'Wyjazd',
  offers_collection_arrival_date: 'Powrót',
  offers_collection_day_count: 'Dni',
  offers_collection_accommodation: 'Zakwaterowanie',
  offers_collection_board: 'Wyżywienie',
  offers_collection_train_to_airport: 'Pociąg na lotnisko',
  search_results: 'Wyniki wyszukiwania',
  saved_searches: 'Zapisane wyszukiwania',
  selected_offers: 'Wybrane oferty',
  add_offers_to_selected: 'Dodaj zaznaczone do wybranych ofert',
  send_offers_collection: 'Wyślij ofertówkę',
  subject: 'Tytuł',
  body: 'Treść',
  all_regions: 'Wszystkie regiony',
  offers_per_hotel_count: 'Liczba ofert na hotel',
  check_prices: 'Sprawdź ceny',
  preview_attachment: 'Podgląd załącznika',
  send_collection_with_email: 'Stwórz ofertówkę z wybranych i wyślij mailem',
  offers_collection_default_email_subject: 'Oferta wakacyjna Amigos',
  add_emails: 'dodaj kolejny adres',
  offers_collection_preview_filename: 'Podgląd ofertówki',
  error_during_offers_collection_preview:
    'Wystąpił błąd przy pobieraniu podglądu ofertówki',
  error_during_offers_collection_send: 'Wystąpił błąd przy wysyłaniu ofertówki',
  error_during_getting_regions_prices:
    'Wystąpił błąd przy pobieraniu cen regionów',
  error_during_saving_filters: 'Wystąpił błąd przy zapisywaniu filtrów',
  NOT_AVAILABLE: 'Niedostępne',
  AVAILABLE: 'Dostępne',
  ON_REQUEST: 'Dostępne na zapytanie',
  chosen_boards: 'Wybrane wyżywienia',
  chosen_accommodations: 'Wybrane zakwaterowania',
  chosen_facilities: 'Wybrane udogodnienia',
  create_offers_collection_pdf: 'Stwórz z wybranych ofertówkę i pobierz pdf',
  request_name: 'Nazwa wyszukiwania',
  unnamed: '[brak nazwy]',
  save_request: 'Zapisz wyszukiwanie',
  reviews: 'opinii',
  offers_collection_email_sent: 'Ofertówka została pomyślnie wysłana',
  pick_from_list: 'Wybierz z listy',
  offers_collection_find_region: 'Znajdź region',
  offers_collection_load_more_offers: 'Pokaż więcej ofert',
  choose_from_saved: 'Wybierz z zapisanych',
  confirm_filters_request_delete: 'Czy na pewno chcesz usunąć to wyszukanie?',

  // BLOG
  search_blog: 'Wyszukaj na blogu ',
  look_for: 'Szukaj',
  departure_from: 'Wylot z ...',
  trip_direction: 'Kierunek podróży',
  adults_count_filter: 'Liczba dorosłych',
  children_count_filter: 'Liczba dzieci',
  similar_entries_label: 'Powiązane atrykuły (widoczne na dole strony)',
  price_from: 'od',
  currency_pln: 'zł',
  per_person: '/os.',
  total: 'razem',
  see_more_offers: 'Zobacz więcej ofert',
  search_for_trip: 'Wyszukaj wycieczkę',

  // HOTELS
  'hotel-name': 'Nazwa hotelu',
  'hotel-location': 'Lokacja',
  'hotel-country-region-city': 'Kraj, Region, Miejscowość',
  'hotel-region-city': 'Region, Miejscowość',
  'hotel-city': 'Miejscowość',
  'hotel-rating': 'Standard',
  'hotel-opinions': 'Ocena',
  no_hotels_found:
    'Nie znaleźliśmy hoteli dla wybranych przez Ciebie parametrów.',
  hotel_name_search_message: 'Wyniki wyszukiwania dla',
  'Not redirecting: empty value of':
    'Nie wykonano przekierowania: pusta wartość',
  search_for_hotel: 'Wyszukaj hotel',
  hotel_list_title: 'Lista hoteli',
  hotel_list_subtitle: 'Wybierz kraj, region lub wyszukaj hotel',
  go_back_to_hotel_list: 'Wróc do listy regionów',

  // RECOMMENDED REGIONS
  recommended_regions_header: 'Polecane kierunki',
  recommended_regions_subheader: 'Wybierz wycieczkę, która pasuje do Ciebie',
  recommended_regions_exotic_tours: 'Egzotyczne wyprawy',
  recommended_regions_nearby_destinations: 'Bliskie kierunki',
  recommended_regions_long_destinations: 'Dalekie kierunki',

  //CATEGORIES SECTION
  get_inspired: 'Gdzie na wakacje? - Zainspiruj się',
  choose_category: 'Wyszukaj idealną ofertę z wybranych kategorii',
  check_categorie: 'Sprawdź oferty',
  look_at: 'Zobacz:',

  //SPECIAL OFFERS
  reservation_type_b: 'B - rezerwacja stała',
  reservation_type_op: 'OP - opcja',
  reservation_type_rq: 'RQ - na zapytanie',
  payment_option_all: 'Całość w dniu podpisania umowy',
  payment_option_advance: 'Zaliczka w dniu podpisania umowy + dopłata',
  contract_in_attachment:
    'w załączniku przesyłamy umowę polską, rezerwację niemiecką, ogólne warunki uczestnictwa organizatora, ogólne warunki ubezpieczenia oraz opis hotelu i świadczeń. Hasłem do otwarcia załączników jest rok urodzenia osoby zawierającej umowę. \nProsimy o sprawdzenie  poprawności wpisanych  danych osobowych i parametrów podróży, następnie prosimy o podpisanie  dokumentów  i odesłanie ich drogą mailową. Informacje dotyczące płatności oraz numery kont znajdują się w polskiej umowie. \nPozostajemy do Państwa dyspozycji',
  additional_information_first_short: 'GODZINY PRZELOTU NIE SĄ WIĄŻĄCE',
  additional_information_first:
    'GODZINY PRZELOTU NIE SĄ WIĄŻĄCE I MOGĄ SIĘ ZMIENIĆ W OBRĘBIE CAŁEGO DNIA',
  additional_information_second_short: 'WYMAGANA WAŻNOŚĆ PASZPORTU',
  additional_information_second:
    'WYMAGANA WAŻNOŚĆ PASZPORTU TO 6 MIESIĘCY OD DATY POWROTU.',
  additional_information_third_short:
    'NA MIEJSCU PŁATNY PODATEK TURYSTYCZNY...',
  additional_information_third:
    'NA MIEJSCU PŁATNY PODATEK TURYSTYCZNY ZALEŻNY OD STANDARDU HOTELU',
  additional_information_fourth_short:
    'DODATKOWO PŁATNA WIZA TURYSTYCZNA W CENIE',
  additional_information_fourth: 'DODATKOWO PŁATNA WIZA TURYSTYCZNA W CENIE ',
  additional_information_fifth_short:
    'REZERWACJA Z OFERTY SPECJALNEJ BEZ MOŻLIWOŚCI ZMIAN...',
  additional_information_fifth:
    'REZERWACJA Z OFERTY SPECJALNEJ BEZ MOŻLIWOŚCI JAKICHKOLWIEK ZMIAN-SZCZEGÓLNE WARUNKI ANULACJI REZERWACJI DO 100% CENY PODRÓŻY',
  additional_information_sixth_short:
    'REZERWACJA Z LOTEM LINIOWYM/ TANIMI LINIAMI BEZ MOŻLIWOŚCI ZMIAN...',
  additional_information_sixth:
    'REZERWACJA Z LOTEM LINIOWYM/ TANIMI LINIAMI BEZ MOŻLIWOŚCI JAKICHKOLWIEK ZMIAN-KOSZTY ANULACJI DO 100% CENY PODRÓŻY',
  additional_information_seventh_short: 'OFERTA ZAWIERA TRANSFER NA MIEJSCU',
  additional_information_seventh: 'OFERTA ZAWIERA TRANSFER NA MIEJSCU',
  additional_information_eighth_short:
    'OFERTA NIE ZAWIERA TRANSFERU NA MIEJSCU',
  additional_information_eighth: 'OFERTA NIE ZAWIERA TRANSFERU NA MIEJSCU',
  additional_information_ninth_short: 'AKCEPTACJA AKTUALNYCH OSTRZEŃ MSZ',
  additional_information_ninth:
    'KLIENT ZAPOZNAŁ SIĘ I ZAAKCEPTOWAŁ AKTUALNE OSTRZEŻENIA MSZ DOTYCZĄCE ZASAD BEZPIECZEŃSTWA ORAZ OBOSTRZEŃ ZWIĄZANYCH Z COVID-19',
  additional_information_tenth_short:
    'POKÓJ EKONOMICZNY/SPAR/BESTPREIS MOŻE BYĆ MNIEJSZY...',
  additional_information_tenth:
    'POKÓJ TYPU EKONOMICZNEGO/ SPAR/ BESTPREIS MOŻE BYĆ MNIEJSZY I/LUB MIEĆ GORSZE POŁOŻENIE',
  additional_information_eleventh_short: 'WIZY DO TURCJI  NALEŻY WYROBIĆ...',
  additional_information_eleventh:
    'WIZY DO TURCJI  NALEŻY WYROBIĆ (INDYWIDUALNIE LUB ZA POŚREDNICTWEM BIURA)  PRZED WYJAZDEM KOSZT',
  additional_information_twelfth_short:
    'ZALECANE SZCZEPIENIA- PROSZĘ SKONTAKTOWAĆ...',
  additional_information_twelfth:
    'ZALECANE SZCZEPIENIA- PROSZĘ SKONTAKTOWAĆ SIĘ Z NAJBLIŻSZĄ STACJĄ SANEPIDU.',
  additional_information_thirteenth_short: 'WYJAZD TYLKO Z WAŻNYM PASZPORTEM',
  additional_information_thirteenth: 'WYJAZD TYLKO Z WAŻNYM PASZPORTEM',
  additional_information_fourteenth_short: 'DZIECI ŚPIĄ Z RODZICAMI',
  additional_information_fourteenth: 'DZIECI ŚPIĄ Z RODZICAMI',
  additional_information_fifteenth_short:
    'PASZPORT LUB DOWÓD WAŻNY MINIMUM 150 DNI (TURCJA)',
  additional_information_fifteenth:
    'PASZPORT LUB DOWÓD MUSI BYĆ WAŻNY JESZCZE PRZEZ MINIMUM 150 DNI, LICZĄC OD DNIA PIERWSZEGO WJAZDU DO TURCJI.',
  additional_information_sixteenth_short:
    'TRANZYT W USA – KONIECZNE JEST WYROBIENIE ...',
  additional_information_sixteenth:
    'TRANZYT W USA – KONIECZNE JEST WYROBIENIE NA KOSZT KLIENTA ESTY LUB WIZY.',
  additional_information_seventeenth_short:
    'KONIECZNE JEST WYROBIENIE WIZY – INDYWIDUALNIE LUB ...',
  additional_information_seventeenth:
    'KONIECZNE JEST WYROBIENIE WIZY – INDYWIDUALNIE LUB ZA POŚREDNICTWEM BURA. KOSZTY WIZY PONOSI KLIENT.',
  additional_information_eighteenth_short:
    'WYZYWIENIE ALL ZGODNIE Z KOMUNIKATEM ...',
  additional_information_eightteenth:
    'WYZYWIENIE ALL ZGODNIE Z KOMUNIKATEM - WLICZONE W CENĘ.',
  additional_information_nineteenth_short: 'TRASA REJSU W ZAŁĄCZNIKU',
  additional_information_nineteenth: 'TRASA REJSU W ZAŁĄCZNIKU.',
  check_special_offers: 'Nie przegap - Super oferty!',
  chosen_by_our_experts: 'Polecane przez naszych specjalistów',
  from_germany: 'Z Niemiec',
  exotic_places: 'Egzotyka',
  with_children: 'Z dziećmi',
  without_passport: 'Bez paszportu',
  more_offers: 'więcej ofert',

  //NEW RESERVATION FORM
  step: 'Krok',
  reservation_participants_description:
    'Nazwiska podane w formularzu rezerwacji muszą być zgodne z danymi zawartymi w paszporcie lub dowodzie osobistym. Jeśli nie wystarczy miejsca na wszystkie imiona, wystarczy podać pierwsze imię. W przypadku trudności z wprowadzeniem danych, prosimy o kontakt z naszym biurem +48 509 663 168.',
  reservation: 'Rezerwacja',
  reservation_participants: 'Uczestnik podróży',
  reservation_field_required: '*Wymagane',
  male: 'Pan',
  female: 'Pani',
  gender: 'Płeć',
  birth_date: 'Data urodzenia',
  nationality: 'Narodowość',
  month: 'Miesiąc',
  year: 'Rok',
  select_gender: 'Wybierz płeć',
  participants: 'Uczestnik podróży',
  age: 'Wiek',
  reservation_customer_data: 'Dane osoby rezerwującej wycieczkę',
  reservation_customer: 'Osoba rezerwująca',
  reservation_customer_description:
    'Jako osoba rezerwująca wycieczkę jesteś osobą upoważnioną do kontaktu z biurem podróży oraz otrzymasz od biura dokumenty. Osoba rezerwująca wycieczkę może, ale nie musi być jednocześnie osobą podróżującą.',
  zip_code: 'Kod pocztowy',
  email: 'E-mail',
  cell_phone: 'Telefon komórkowy',
  phone: 'Telefon',
  country: 'Kraj',
  city: 'Miasto',
  street_and_house_number: 'Ulica i numer domu',
  continue: 'dalej',
  return: 'powrót',
  overview: 'Podgląd',
  payment_method: 'Metoda płatności',
  payment_method_CC: 'Karta kredytowa',
  payment_method_BE: 'Polecenie zapłaty',
  payment_method_TF: 'Rejestracja telefoniczna',
  payment_method_RE: 'Faktura',
  final_information: 'Informacja końcowa',
  reservation_hint: 'Informacje od organizatora',
  client_request: 'Uwagi klienta',
  client_request_info:
    'Uwagi od klienta nie zostaną zawarte w umowie (max. 60 znaków)',
  mobility: 'Informacje dot. mobilności',
  mobility_info:
    'Ta wycieczka nie jest odpowiednia dla osób o <b>ograniczonej</b> sprawności ruchowej',
  important_note: 'Ważna informacja',
  important_note_info:
    'Po dokonaniu rezerwacji otrzymacie Państwo email z potwierdzeniem rezerwacji. Jeżeli Państwo nie otrzymacie wiadomości email, prosimy o kontakt z biurem: +48 509 663 168 / rezerwacje@wakacjeamigos.pl',
  cost_summary: 'Podsumowanie kosztów',
  travel_cost: 'Cena podróży ze wszystkimi dopłatami',
  pay_and_book: 'Zapłać i zarezerwuj',
  regulations: 'Ogólne warunki handlowe (OWH)',
  invalid_gender: 'Proszę wybrać płeć.',
  invalid_name: 'Proszę wprowadzić nazwisko.',
  invalid_date: 'Proszę wprowadzić datę urodzenia.',
  invalid_destination: 'Proszę wprowadzić kierunek podróży.',
  invalid_country: 'Proszę wybrać kraj.',
  invalid_email: 'Proszę wprowadzić adres e-mail.',
  invalid_phone: 'Proszę wprowadzić numer telefonu.',
  invalid_city: 'Proszę wprowadzić miejsce zamieszkania.',
  invalid_zip_code: 'Proszę wprowadzić kod pocztowy.',
  invalid_address: 'Proszę wprowadzić ulicę i numer domu.',
  invalid_participants_number: 'Proszę wprowadzić liczbę uczestników podróży.',
  invalid_departure: 'Proszę wprowadzić miejsce wylotu/wyjazdu.',

  travel_insurance: 'Ubezpieczenie podróżne',
  travel_insurance_description: 'Zarezerwuj ubezpieczenie na cały pobyt.',
  first_option_insurance:
    'Nie chcę oferowanego ubezpieczenia podróżnego. W swoim zakresie pokryję wszelkie koszty od następstw nieszczęsliwych wypadków w podróży i kosztów leczenia za granicą.',
  second_option_insurance: 'Tak, chcę wybrać ubezpieczenie.',
  insurance: 'Ubezpieczenie',
  insurance_cost: 'Ubezpieczenie rodzinne / podlegające odliczeniu',
  info: 'INFO',
  regulations_text_1:
    '<p>* Zapoznałem/-am się i akceptuję regulamin organizatora wycieczki, regulamin wyjazdu oraz przepisy dotyczące podróży. Obowiązują przepisy dotyczące wjazdu oraz szczepień do kraju docelowego i tranzytowego odpowiadające obywatelstwu każdego uczestnika. Przepisy dotyczące obywateli niemieckich można znaleźć na stronach <a href=https://www.auswaertiges-amt.de/de/ReiseUndSicherheit/reise-und-sicherheitshinweise target="_blank">Ministerstwo Spraw Zagranicznych</a></p>',
  regulations_text_2: '<br><p>Proszę potwierdzić dane osobowe.</p><br>',
  conditions_text:
    '<p>* Zapoznałem/-am się z kartą informacyjną oraz danymi kontaktowymi podanymi w załączniku i akceptuję <a href="" target=_blank>Warunki ubezpieczenia.</a></p>',
  step4_documents: 'Dokumenty do pobrania',
  step4_conditions: 'OWH i anulowanie (operator wycieczki)',
  step4_forms: 'Arkusze formularza',
  step4_visa: 'Wymogi dotyczące wyjazdu',

  registration_confirmation: 'Potwierdzenie rezerwacji',
  initial_registration_confirmation: 'Potwierdzenie rezerwacji wstępnej',
  step5_thanks_for_reservation_1:
    'Dziękujemy za Twoją rezerwację, w ciągu 15 minut otrzymasz wiadomość e-mail z podsumowaniem.',
  step5_thanks_for_reservation_1_insurance:
    'Dziękujemy za Twoją rezerwację, w ciągu 15 minut otrzymasz wiadomość e-mail z podsumowaniem i danymi do wpłaty za wybrane ubezpieczenie.',
  step5_thanks_for_reservation_2:
    'Jeśli nie otrzymasz wiadomości e-mail, prosimy o kontakt z biurem: +48 509 663 168 /',
  order_numbers_for_inquiries: 'Podsumowanie zamówienia',
  post_date: 'Data rezerwacji:',
  order_numer: 'Numer zlecenia:',
  summary_costs: 'Podsumowanie kosztów',
  price_trip: 'Cena wycieczka z wszystkimi dopłatami',
  identity: 'Identyfikacja',
  select_identity: 'Wybierz sposób identyfikacji',
  issue_date: 'Data wystawienia',
  valid_date: 'Data wygaśnięcia',
  invalid_identity_date: 'Nieprawidłowe dane',
  filed_required: 'To pole jest wymagane',
  choose_insurance: 'Wybierz ubezpieczenie podróżne',
  passport: 'Paszport',
  identity_card: 'Dowód osobisty',
  trip_price: 'Cena wycieczki',
  pesel_for_old_contract: 'Umowa została sporządzona na podstawie numeru PESEL',

  invoice: 'Faktura',
  'credit card': 'Karta kredytowa',
  sepa: 'SEPA',
  'direct debit': 'Polecenie zapłaty',
  paypal: 'Paypal',

  group_reservation_info: 'Informacje o wycieczce grupowej',
  group_reservation_destination: 'Kierunek podróży',
  group_reservation_from: 'Wyjazd (od)',
  group_reservation_to: 'Powrót (do)',
  group_reservation_max_price: 'Maks. cena/os. w euro',
  group_reservation_participants_number: 'Liczba uczestników',
  group_reservation_offer_type: 'Typ transportu',
  group_reservation_departure_from: 'Wylot/wyjazd z',
  group_reservation_comment: 'Komentarz',
  group_reservation_your_email: 'Twój e-mail',
  group_reservation_thank_you: 'Dziękujemy za twoją wiadomość!',
  group_reservation_contact_msg_1: 'Skontaktujemy się z Państwem',
  group_reservation_contact_msg_2: 'w przeciągu 48 godzin',

  person_data: 'Dane osobiste',
  bus: 'Autobus',
  flight: 'Samolot',
  self_arrival: 'Własny',
  phone_or_mobile_number: 'Numer telefonu lub komórkowy',
  club: 'Stowarzyszenie/Klub',
  data_protection_consent_header: 'Zgoda na ochronę danych:',
  data_protection_content:
    'Wyrażam zgodę na przetwarzanie danych osobowych przez firmę Amigos B.B. Sp z o.o. zawartych w formularzu w celach związanych z obsługą zamówienia. Zapoznałem się z dokładnymi szczegółami przetwarzania moich danych, a także z przysługującymi mi prawami w związku z przetwarzaniem danych, jak wyjaśniono w oświadczeniu o ochronie danych.',
  data_protection_error: 'Zaznacz zgodę na ochronę danych.',
  data_protection: 'Ochrona danych:',
  data_protection_info:
    'Twoje dane będą przechowywane lub wykorzystywane wyłącznie do wewnętrznych celów firmy w celu realizacji oferowanej usługi. Możesz odwołać tę zgodę w dowolnym momencie, wysyłając e-mail na adres rezerwacje@wakacjeamigos.pl lub telefonicznie. Podobnie dane nie będą przekazywane stronom trzecim, chyba że jesteśmy do tego prawnie zobowiązani. Potwierdzając zgodę, zezwalasz nam również na kontakt telefoniczny lub mailowy w sprawie zamówienia. Podanie numeru telefonu i adresu e-mail jest jednak dobrowolne. Aby uzyskać szczegółowe informacje o ochronie danych, kliknij nasz przycisk ochrony danych w stopce!',
  request_free_offer: 'Zapytaj o ofertę',

  add_page: 'Dodaj stronę',
  please_correct: 'Proszę rozwiązać następujące problemy:',
  required: 'Wymagane',
  url_address: 'Adres URL',
  thumbnail: 'Miniaturka',
  add: 'Dodaj',
  nr: 'NR',
  is_active: 'Aktywny?',
  actions: 'Akcje',
  page_name: 'Nazwa strony',
  category_link: 'Przejdź do strony z ofertami',

  add_url_error: 'Podaj adres URL oferty',
  wrong_url_error: 'Niepoprawny adres URL oferty',
  add_thumbnail_error: 'Załącz miniaturkę do oferty',

  confirm_tv_offers_category_delete:
    'Czy na pewno chcesz usunąć tę stronę z ofertami?',
  confirm_tv_offer_delete: 'Czy na pewno chcesz usunąć tę ofertę?',

  scan_qr: 'Zeskanuj kod QR i sprawdź tę ofertę:',
  departure_colon: 'Wylot:',
  pln_per_person: 'zł/os.',
  site_name: 'wakacjeamigos.pl',

  last_check_availability: 'Dostępność',
  only_available: 'Tylko dostępne',
  only_unavailable: 'Tylko niedostępne'
};



// WEBPACK FOOTER //
// ./common/locale/pl.js